module.exports = __webpack_public_path__ + "static/media/bg-not-join.9ffb313d.png";